import { defineMessages } from 'react-intl';

export default defineMessages({
  collateralComposition: { defaultMessage: 'Collateral Composition' },
});
